module.exports = __webpack_public_path__ + "img/about_4.abb47094.jpg";